.scoreLineContainer {
    width: 100%;
    height: 60px;
}

:root {
    --score-line-red-info: #e11a32;
    --score-line-green-info: #00a171;
    --score-line-edge-range: 10%;
    --score-line-red: #ffa9a3;
    --score-line-yellow: #fedf89;
    --score-line-green: #94f2c3;
}

//0->15% is UNDER , 15% -> 85% is OK, 85% -> 100% is OVER
.scoreLine {
    position: relative;
    --edge-range: var(--score-line-edge-range);
    --edge-range-end: calc(100% - var(--edge-range));
    //border: 1px solid #212529aa;
    border-radius: 5px;
    height: 15px;
    width: 100%;
}

.scoreLineRangedGradient {
    background: linear-gradient(
        90deg,
        #f1f3f6 0%,
        #f1f3f6 var(--edge-range),
        var(--score-line-red) var(--edge-range),
        var(--score-line-yellow) 60%,
        var(--score-line-green) var(--edge-range-end),
        #f1f3f6 var(--edge-range-end),
        #f1f3f6 100%
    );
}

.scoreLineGreaterThan {
    background: linear-gradient(
        90deg,
        #f1f3f6 0%,
        #f1f3f6 var(--edge-range),
        var(--score-line-red) var(--edge-range),
        var(--score-line-red) 45%,
        var(--score-line-green) 55%,
        var(--score-line-green) var(--edge-range-end),
        #f1f3f6 var(--edge-range-end),
        #f1f3f6 100%
    );
}
.edgeLine {
    position: absolute;
    height: 24px;
    width: 2px;
    //border-left: 2px dashed var(--color);
    background: linear-gradient(
        0deg,
        var(--color) 0%,
        var(--color) 59%,
        transparent 60%,
        transparent 100%
    );
    background-size: 1px 4px;
    top: -2px;
}

.edgeLineGreen {
    --color: var(--score-line-green-info);
    right: var(--score-line-edge-range);
    .edgeLine();
}

.edgeLineRed {
    --color: var(--score-line-red-info);
    left: var(--score-line-edge-range);
    .edgeLine();
}

.label {
    position: absolute;
    height: 30px;
    color: var(--color);
    font-family: Hanken Grotesk;
    font-weight: 600;
    font-size: 15px;
}
.leftLabel {
    --color: var(--score-line-red-info);
    left: var(--score-line-edge-range);
    transform: translate(-50%, 20px);
    .label();
}
.centerLabel {
    --color: #667085;
    left: 50%;
    transform: translate(-50%, 20px);
    .label();
}

.middleLabel {
    --color: var(--score-line-green-info);
    left: 50%;
    transform: translate(-50%, 20px);
    .label();
}
.rightLabel {
    --color: var(--score-line-green-info);
    right: var(--score-line-edge-range);
    transform: translate(50%, 20px);
    .label();
}

.tooltip_tip {
    &::before {
        position: absolute;
        left: calc(50% - 5px);
        bottom: -6px;
        transform: rotate(45deg);
        background-color: var(--background);
        border-right: 2px solid var(--border);
        border-bottom: 2px solid var(--border);
        content: '';
        width: 10px;
        height: 10px;
    }
}
.tooltip {
    background-color: var(--background);
    border: 2px solid var(--border);
    color: white;
    border-radius: 20;
    text-align: center;
    font-weight: 600;
}

.tooltipRed {
    --background: #f97066;
    --border: #e11a32;
    .tooltip();
}

.tooltipYellow {
    --background: #f79009;
    --border: #dc6803;
    .tooltip();
}

.tooltipGreen {
    --background: #47cd89;
    --border: #00a171;
    .tooltip();
}

.textEntry {
    height: 30px;
    width: 60px;
    position: absolute;
    transform: translate(-50%, -50%);
}

.scoreLineEntry {
    .textEntry();
    transform: translate(-50%, -40px) !important;
}

.grayFilter {
    background-color: #b9b9b9 !important;
    border-color: #d5d5d5 !important;
    filter: grayscale(50%);
}
